import React from '../helpers/react';

export const CommentModerationBox = React.createClass({
    deleteComment: function() {
        this.props.removeComment(this.props.commentData.commentId, this.props.solutionId, this.props.problemId);
    },
    render: function() {
        let commentData = this.props.commentData;
        let button = commentData.commentId ? <button role="button" onClick={this.deleteComment} aria-label={this.props.getDef('comments.remove')}>{this.props.getDef('comments.remove')}</button> : '';

        return <section className="comment-moderation">
            <dl>
                <dt>User ID</dt>
                <dd className="comment-userid">{commentData.userId}</dd>
                <dt>Email</dt>
                <dd className="comment-email">{commentData.userEmailAddress}</dd>
            </dl>
            {button}
        </section>;
    }
});

export default CommentModerationBox;


// WEBPACK FOOTER //
// ./src/components/CommentModerationBox.js